import CustomLink from 'components/TableLink';
import { tableStyles } from 'css/tableStyles';
import React, { useMemo } from 'react';
import DataTable from 'components/DataTable';
import _ from 'lodash';
import { sanitizeInventoryItemsWithInventoryAddress, sortAlphaNum } from 'utils';
import ImageWrapper from 'components/ImageWrapper/index';

const OrderItemCountPickPack = props => {
  const { itemMap = [] } = props.data;
  const columns = useMemo(() => [
    {
      name: 'Order Item ID',
      selector: 'objectId',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => (
        <CustomLink
          text={row.objectId}
          linkTo={`/inventory-items/${row.objectId}`}
        />
      ),
    },
    {
      name: 'Slot No',
      selector: 'slotNo',
      sortable: true,
      sortFunction: sortAlphaNum,
    },
    {
      name: 'Item Image',
      selector: 'image',
      cell: row => (
        <ImageWrapper src={row.image} className={'sized-image'} clickForFullScreen />
      ),
    },
    {
      name: 'Count',
      selector: 'count',
    },
    {
      name: 'Unit',
      selector: 'unit',
    },
    {
      name: 'Name',
      selector: 'name',
    },
    {
      name: 'Inventory Address',
      selector: 'inventoryAddress',
      sortable: true,
      format: row => row.inventoryAddress ?? '-',
    },
    {
      name: 'Category',
      selector: 'category',
    },
  ], []);

  const itemMapWithSanitizedInventoryAddress = useMemo(()=>{
    return sanitizeInventoryItemsWithInventoryAddress(itemMap);
  }, [itemMap]);

  return (
    <DataTable
      keyField="objectId"
      columns={columns}
      noHeader={true}
      data={itemMapWithSanitizedInventoryAddress}
      highlightOnHover={true}
      customStyles={tableStyles}
    />
  );
};


export { OrderItemCountPickPack };
